import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FacebookPixel() {
  const location = useLocation();
  const initialized = useRef(false);
  const scrollMilestones = useRef(new Set());
  const timeMilestones = useRef(new Set());

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await axios.get(`${API}/settings/marketing`);
        const pixelId = res.data?.facebook_pixel_id;
        if (!pixelId || !mounted) return;

        if (!window.fbq) {
          /* eslint-disable */
          !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
          n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
          document,'script','https://connect.facebook.net/en_US/fbevents.js');
          /* eslint-enable */
        }
        window.fbq('init', pixelId);
        window.fbq('track', 'PageView');
        initialized.current = true;
      } catch (e) {
        // silencioso
      }
    })();
    return () => { mounted = false; };
  }, []);

  // Track page views, scroll, and time
  useEffect(() => {
    if (initialized.current && window.fbq) {
      window.fbq('track', 'PageView');
    }

    // Reset milestones on route change
    scrollMilestones.current.clear();
    timeMilestones.current.clear();

    const handleScroll = () => {
      if (!initialized.current || !window.fbq) return;
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollHeight <= 0) return;
      
      const scrollPercent = (window.scrollY / scrollHeight) * 100;
      const milestones = [25, 50, 75, 90];
      
      for (const m of milestones) {
        if (scrollPercent >= m && !scrollMilestones.current.has(m)) {
          scrollMilestones.current.add(m);
          window.fbq('trackCustom', 'Scroll', { depth: `${m}%` });
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    // Time intervals
    const timers = [];
    const timeIntervals = [15, 30, 60, 120];
    
    timeIntervals.forEach(seconds => {
      const timer = setTimeout(() => {
        if (initialized.current && window.fbq && !timeMilestones.current.has(seconds)) {
          timeMilestones.current.add(seconds);
          window.fbq('trackCustom', 'TimeOnPage', { seconds });
        }
      }, seconds * 1000);
      timers.push(timer);
    });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      timers.forEach(t => clearTimeout(t));
    };
  }, [location.pathname]);

  return null;
}
